import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from "react-select";
import { selectStyles } from "../helper/SelectStyles";
import { useNavigate, Link } from "react-router-dom";
import TablePagination from "./TablePagination";

const AssignedLayer = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        expoName: null,
        employeeName: null,
    });

    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [totalRecords, setTotalRecords] = useState(122);

    const data = [
        {
            expoName: "Build Expo - test",
            employeeName: "Chandra lekha",
            companyName: "A G S Enterprises/ Shruthi Homess & Paving Blocks",
            keyPerson: "Shiva Kumar",
            mobile: "7200798333/9840231440",
            city: "Chennai",
            isVIP: true
        },
        {
            expoName: "Build Expo - test",
            employeeName: "Chandra lekha",
            companyName: "A.P. Technology",
            keyPerson: "Dinakaran",
            mobile: "7838608916",
            city: "Chennai",
            isVIP: true
        },
        {
            expoName: "Build Expo - test",
            employeeName: "Chandra lekha",
            companyName: "Aadhi Solar Solutions",
            keyPerson: "Kamalakannan",
            mobile: "9176362015",
            city: "Chennai",
            isVIP: true
        }
    ];

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between" style={{ background: "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)" }}>
                <h6 className="text-white pb-2 mb-0">Assigned</h6>
                <button
                    onClick={() => navigate(-1)}
                    className="btn btn-sm d-flex align-items-center gap-2 text-white"
                    style={{ backgroundColor: "rgba(255,255,255,0.2)", border: "1px solid white" }}
                >
                    <Icon icon="solar:alt-arrow-left-bold" />
                    Back
                </button>
            </div>
            <div className="card-body p-24">
                <div className="p-24 radius-12 mb-24" style={{ backgroundColor: "#f7e7da" }}>
                    <div className="row g-3 align-items-end">
                        <div className="col-md-5">
                            <label className="form-label fw-bold">Expo Name :</label>
                            <Select styles={selectStyles()} placeholder="-- Select --" />
                        </div>
                        <div className="col-md-5">
                            <label className="form-label fw-bold">Employee Name :</label>
                            <Select styles={selectStyles()} placeholder="-- Select --" />
                        </div>
                        <div className="col-md-2 mt-16">
                            <button className="btn btn-primary-600 px-32 py-10 radius-8 h-42-px w-80 uppercase fw-bold">Search</button>
                        </div>
                    </div>
                </div>

                {/* <div className="mb-24">
                    <h2 className="text-danger-600 fw-bold mb-16">Assigned</h2>
                    <div className="d-flex flex-wrap gap-2 justify-content-end text-xs fw-bold align-items-center">
                        <span className="text-success-main">VIP Customer( 15 )</span>
                        <span className="text-success-main">Existing Customer( 94 )</span>
                        <span className="text-success-main">Other Expo Participant( 11 )</span>
                        <span className="text-success-main">Enquiries( 2 )</span>
                    </div>
                    <div className="d-flex flex-wrap gap-2 justify-content-end text-xs fw-bold align-items-center mt-2">
                        <span className="text-success-main underline">Assigned ( 122 )</span>
                        <span className="text-warning-main">Prospects ( 0 )</span>
                        <span className="text-success-main">Booked ( 0 )</span>
                        <span className="text-secondary-light">Not Interest ( 0 )</span>
                        <span className="text-warning-main">Correction ( 1 )</span>
                        <span className="text-dark">All ( 123 )</span>
                    </div>
                </div> */}

                {/* <div className="d-flex align-items-center justify-content-between mb-16 flex-wrap gap-3">
                    <div className="d-flex align-items-center gap-2">
                        <span>Search:</span>
                        <input type="text" className="form-control form-control-sm" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    </div>
                </div> */}

                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0 text-center">
                        <thead>
                            <tr style={{ backgroundColor: "#f7e7da" }}>
                                <th style={{ color: "black", fontWeight: "bold" }}>Expo Name</th>
                                <th style={{ color: "black", fontWeight: "bold" }}>Employee Name</th>
                                <th style={{ color: "black", fontWeight: "bold" }}>Company Name</th>
                                <th style={{ color: "black", fontWeight: "bold" }}>Key Person</th>
                                <th style={{ color: "black", fontWeight: "bold" }}>Mobile</th>
                                <th style={{ color: "black", fontWeight: "bold" }}>City</th>
                                <th style={{ color: "black", fontWeight: "bold" }}>Ratings</th>
                                <th style={{ color: "black", fontWeight: "bold" }}>Business History</th>
                                <th style={{ color: "black", fontWeight: "bold" }}>Call History</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.expoName}</td>
                                    <td>{item.employeeName}</td>
                                    <td>{item.companyName}</td>
                                    <td>{item.keyPerson}</td>
                                    <td>{item.mobile}</td>
                                    <td>{item.city}</td>
                                    <td>
                                        {item.isVIP && (
                                            <span className="w-40-px h-40-px border border-danger-600 rounded-circle d-flex align-items-center justify-content-center mx-auto text-danger-600 fw-bold text-xs">VIP</span>
                                        )}
                                    </td>
                                    <td>
                                        <button className="btn btn-sm text-dark fw-bold text-xs uppercase" style={{ border: "none", background: "none" }}>Business History</button>
                                    </td>
                                    <td>
                                        <button className="btn btn-sm text-dark fw-bold text-xs uppercase" style={{ border: "none", background: "none" }}>Show call history</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <TablePagination
                    currentPage={currentPage}
                    totalPages={Math.ceil(totalRecords / rowsPerPage)}
                    onPageChange={(page) => setCurrentPage(page)}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(e) => {
                        setRowsPerPage(Number(e.target.value));
                        setCurrentPage(0);
                    }}
                    totalRecords={totalRecords}
                />
            </div>
        </div>
    );
};

export default AssignedLayer;


